export const ChannelsSettingsSubMenuRoutes = {
  DEFAULT: '/whatsapp/logs',
  WHATSAPP_TEMPLATES: '/whatsapp/templates',
  MANAGE_WHATSAPP_TEMPLATES: '/whatsapp/manage-template',
  WHATSAPP_EVENT_MAPPING: '/whatsapp/event-mapping',
  WHATSAPP_LOGS: '/whatsapp/logs',
  EMAIL_TEMPLATES: '/email/templates',
  MANAGE_EMAIL_TEMPLATE: '/email/manage-template',
  EMAIL_LOGS: '/email/logs',
  EMAIL_EVENT_MAPPING: '/email/event-mapping',
};
